import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import MyobSettingsHtml from './myob.settings.html';

export function MYOBStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'MYOBSettingsCtrl',
    name       : 'app.myob-settings',
    templateUrl: MyobSettingsHtml,
    url        : '/myob_settings',
    resolve    : {
      accountingSettings: ( $rootScope : any ) : ng.IPromise<any> => $rootScope.Company.getAccountingSettings(),
      company_settings  : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_settings'),
      session           : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      settings          : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company')
    }
  });
}